<template>
  <hm-content title="">
    <div class="flex">
      <div class="search-left">
        <div class="line-title">选择筛选条件</div>
        <div class="bg mt20">
          <!-- <div class="openAll mb10 flex flex-end" @click="openAll">
            全部展开
          </div> -->
          <el-collapse v-model="activeNames" @change="handleChange">
            <el-collapse-item
              :name="v.id"
              v-for="(v, i) in tagAttributeList"
              :key="i"
            >
              <template slot="title">
                <div class="collapse-title flex item-center">
                  {{ v.catName
                  }}<span class="num" v-if="v.catNum">{{ v.catNum }}</span>
                </div>
              </template>
              <div class="flex flex-between flex-wrap item-center">
                <div
                  class="collapse-item"
                  :class="{ 'collapse-item-active': item.checked }"
                  v-for="(item, index) in v.childrenList"
                  :key="index"
                  @click="showTag(v, item)"
                >
                  {{ item.tagName }}
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
      <div class="search-right flex-1 ml20">
        <div class="line-title">人群同时满足以下特征</div>
        <div class="bg mt20">
          <div class="group-list">
            <template v-for="(v, i) in tagAttributeList">
            <div
              class="group-item mt20"
              :key="i"
              v-if="v.catNum"
            >
              <div class="group-title">{{ v.catName }}</div>
              <template v-for="(o, oindex) in v.childrenList">
                <div class="tagName" :key="oindex" v-if="o.checked">
                  {{ o.tagName }}
                  <div class="mt10">
                    <el-checkbox-group
                      v-model="o.tagNameListGroup"
                      @change="tagRunInfoListChange"
                    >
                      <el-checkbox
                        v-for="(p, pindex) in o.tagDetails.tagRunInfoList"
                        :label="p.tagName"
                        :key="pindex"
                        >{{ p.tagName }}</el-checkbox
                      >
                    </el-checkbox-group>
                  </div>
                  <!-- <div class="mt10">
                    <el-select
                        clearable
                        v-model="o.tagNameListSelect"
                        :placeholder="'请选择' + o.tagName"
                        size="small"
                        filterable
                        @change="getCheckedTag"
                        multiple
                    >
                      <el-option
                          :label="p.tagName"
                          :value="p.tagName"
                          v-for="(p, pindex) in o.tagDetails.tagRunInfoList"
                          :key="pindex"
                      ></el-option>
                    </el-select>
                  </div> -->

                </div>
              </template>
            </div>
            </template>
          </div>
          <div class="flex item-center estimate">
            <div class="ml30 mr20" v-if="estimateCount > -1">预估人数：
              {{estimateCount}} 人</div>
            <div class="ml30 mr20" v-if="estimateCount == -1">预估人数：
              -人</div>
            <el-button type="primary" size="small" @click="estimate"
              >估算</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <div class="mt20">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="人群名称：" prop="groupName">
          <el-input
            type="text"
            v-model.trim="ruleForm.groupName"
            clearable
            placeholder="请输入人群名称"
            size="small"
            style="width: 900px"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="flex flex-center mt20">
      <el-button type="primary" size="small" @click="submitForm('ruleForm')"
        >提交</el-button
      >
      <el-button size="small" @click="$router.back(-1)">取消</el-button>
    </div>
  </hm-content>
</template>
<script>
import { mapGetters } from "vuex";
import * as XLSX from "xlsx/xlsx";
import { getCookie, setCookie } from "@/utils/utils";
import moment from "moment";
import {getLoginUser} from "@/utils/auth";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串

export default {
  components: {},
  data() {
    return {
      queryType: "user",
      activeNames: [],
      ruleForm: {
        groupName: "",
        groupInfo: [],
      },
      rules: {
        groupName: {
          required: true,
          message: "请输入人群名称",
          trigger: "blur"
        },
      },
      tagAttributeList: [],
      currentPage: 1,
      pageSize: 99,
      searchConditions: {
        tagCat: "",
      },
      currentIndex: -1,
      groupInfo: [],
      estimateCount: -1,
    };
  },
  created() {
  },
  mounted() {
    this.queryAllTag();
  },
  methods: {
    // openAll() {
    //   this.activeNames = ["1", "2"];
    // },
    handleChange(val) {
      console.log(val);
      val.forEach((v) => {
        this.tagAttributeList.forEach((o, i) => {
          if (v === o.id) {
            if (o.childrenList && !o.childrenList.length) {
              this.tagCat = o.id;
              this.currentIndex = i;
              this.queryList();
            }
          }
        });
      });
    },
    async queryAllTag() {
      const { storeCode } = getLoginUser();
      const { result } = await this.$store.dispatch("queryAllTagCat", {
        queryType: this.queryType,
        fromType: "group",
        tenantId: storeCode
      });
      this.tagAttributeList = result;
      this.tagAttributeList.forEach((v) => {
        v.catNum = 0;
        v.childrenList = [];
      });
    },
    async queryList() {
      console.log("queryList!!!");
      const { result } = await this.$store.dispatch("queryTagList", {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        tagCat: this.tagCat,
        tagType: this.queryType,
        queryType: "group",
        delFlag: "0",
      });
      const { records, total } = result;
      this.tagAttributeList[this.currentIndex].childrenList = records;
      this.tagAttributeList[this.currentIndex].childrenList.forEach((v) => {
        v.checked = false;
        v.tagDetails = {};
        v.tagNameListGroup = [];
        v.tagNameListSelect = [];
      });
      this.tagAttributeList = JSON.parse(JSON.stringify(this.tagAttributeList));
    },
    async showTag(row, childrenRow) {
      childrenRow.checked = !childrenRow.checked;
      row.catNum = 0;
      row.childrenList.forEach((v) => {
        if (v.checked) {
          row.catNum++;
        }
      });
      console.log("childrenRow.tagNameListGroup:",childrenRow.tagNameListGroup);
      if(childrenRow.checked){
        childrenRow.tagNameListGroup = [];
        const { result } = await this.$store.dispatch("queryTagDetails", {
          id: childrenRow.id,
        });
        childrenRow.tagDetails = result;
        childrenRow.tagDetails.tagRunInfoList = JSON.parse(
          childrenRow.tagDetails.tagRunInfo
        );
        console.log(
          "childrenRow.tagDetails.tagRunInfoList:",
          childrenRow.tagDetails.tagRunInfoList
        );
        childrenRow.tagDetails = JSON.parse(
          JSON.stringify(childrenRow.tagDetails)
        );
        console.log("childrenRow.tagDetails:", childrenRow.tagDetails);
      }
    },
    async submitForm(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        this.queryGroupInfo();
        if(!this.groupInfo.length){
          this.$message({
            message: "请选择标签",
            type: "warning"
          });
          return;
        }
        this.ruleForm.groupInfo = JSON.stringify(this.groupInfo);
        const params = JSON.parse(JSON.stringify(this.ruleForm));
        console.log("params:",params);
        // return;
        const { code } = await this.$store.dispatch("tagGroupAdd", params);
        if(code === '0'){
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.$router.back(-1);
        }
      }
    },
    tagRunInfoListChange(val) {
      console.log(val);
    },
    getCheckedTag(val){
      console.log(val);
    },
    queryGroupInfo(){
      this.groupInfo = [];
      this.tagAttributeList.forEach(v=>{
        if(v.catNum){
          console.log(v.catName);
          v.childrenList.forEach(o=>{
            if(o.checked && o.tagNameListGroup && o.tagNameListGroup.length){
              console.log("o.tagNameListGroup:",o.tagNameListGroup);
              this.groupInfo.push({
                categoryId: v.id,
                tagId: o.id,
                calcValue: o.tagNameListGroup,
              })
            }
          })
        }
      })
      console.log("this.groupInfo:",this.groupInfo);
    },
    async estimate() {
      console.log("估算");
      this.queryGroupInfo();
      if(!this.groupInfo.length){
        this.$message({
          message: "请选择标签",
          type: "warning"
        });
        return;
      }
      this.ruleForm.groupInfo = JSON.stringify(this.groupInfo);
      const params = {
        groupInfo: this.ruleForm.groupInfo
      };
      console.log("params:",params);
      const { code, result } = await this.$store.dispatch("tagGroupEstimate", params);
      if(code === '0'){
        this.estimateCount = result;
        console.log("result:",result);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.line-title {
  color: #222222;
  font-weight: bold;
  &::before {
    display: inline-block;
    margin-right: 10px;
    content: "";
    width: 4px;
    height: 14px;
    background: #e50065;
  }
}
.openAll {
  color: #0081e5;
  cursor: pointer;
}
.search-left {
  width: 360px;
  .bg {
    padding: 20px;
    border-radius: 6px;
    background: #f7f7f7;
    border: 1px solid #d4d4d4;
  }
  .collapse-title {
    padding-left: 20px;
    .num {
      width: 20px;
      height: 20px;
      line-height: 20px;
      background: #e50065;
      border-radius: 50%;
      color: #ffffff;
      margin-left: 10px;
      text-align: center;
      display: block;
    }
  }
  .collapse-item {
    width: 150px;
    height: 32px;
    background: #ffffff;
    border-radius: 4px;
    opacity: 1;
    border: 1px solid #dddddd;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    color: #222222;
    margin-top: 10px;
    cursor: pointer;
  }
  .collapse-item-active {
    width: 150px;
    height: 32px;
    background: #fbebf2;
    border-radius: 4px;
    opacity: 1;
    border: 1px solid #e50065;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    color: #e50065;
  }
}
.search-right {
  .bg {
    border-radius: 6px;
    background: #f7f7f7;
    border: 1px solid #d4d4d4;
  }
  .group-list {
    padding: 20px;
    padding-bottom: 20px;
    .group-item {
      padding: 20px;
      background: #ffffff;
      border-radius: 8px;
      border: 1px solid #dddddd;
      .group-title {
        font-weight: bold;
        color: #222222;
      }
      .tagName {
        font-weight: bold;
        color: #222222;
        margin-left: 30px;
        margin-top: 30px;
      }
    }
  }
  .estimate {
    padding: 20px 0;
    box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.1);
  }
}
/deep/ .el-collapse-item__header {
  background: none !important;
}
/deep/ .el-collapse-item__wrap {
  background: none !important;
}
.ml30 {
  margin-left: 30px;
}
</style>
